import React from 'react';
export var FormLayout = function (children) { return (React.createElement("div", null, children)); };
//# sourceMappingURL=FormLayout.js.map